export const getCategoriesOrderList = () => [
    "I-Codes",
    "United States",
    "Global",
    "Standards",
    "Commentaries",
    "Resources",
    "Topics",
    "Publisher",
    "Collections",
];

const applySorting = (a, b, sortOrder, key) => {
    const aValue = a[key] || '';
    const bValue = b[key] || '';

    const ai = sortOrder.indexOf(aValue);
    const bi = sortOrder.indexOf(bValue);

    if (ai === -1 && bi === -1) {
        return aValue.localeCompare(bValue);
    }

    if (ai === -1) return 1;
    if (bi === -1) return -1;

    return ai - bi;
};

export const getTopLevelOrderedCategories = (categories, key = 'name') => {
    const sortOrder = getCategoriesOrderList();
    return categories.slice().sort((a, b) => applySorting(a, b, sortOrder, key));
};
